import { ORDERS_PER_PAGE_LIMIT } from '@@partner:config'
import { NO_PHOTO_IMAGE } from '@@partner:config/image'
import { useMutateSyncProductsToGroup } from '@@partner:graphql/mutation/productGroup/syncProductsToGroup.gql'
import { useQueryProducts } from '@@partner:graphql/query/catalog/products.gql'
import { useGridHelper } from '@@partner:helpers/crud/grid'
import { convertToInt } from '@@partner:helpers/util'
import { ProductListItem } from '@@partner:types:app'
import { GQL_ID, NestedFilter } from '@@partner:types:graphql'
import CommonStatusLabel from '@components/common/CommonStatusLabel'
import React from 'react'
import { Avatar, Button, Pagination, Panel, Table } from 'rsuite'

const { Column, HeaderCell, Cell } = Table

export interface ProductGroupProductsTableProps {
  groupId: GQL_ID
  refetchRef?: React.MutableRefObject<(() => void) | undefined>
}

export default function ProductGroupProductsTable ({ groupId, refetchRef }: ProductGroupProductsTableProps) {
  const { page, tableSort, handlePageSelect, handleSortColumn } =
    useGridHelper()

  const filter: NestedFilter = {
    fields: [ 'productGroupIds' ],
    op: 'eq',
    value: [ convertToInt(groupId) ]
  }

  const [ syncProducts, { loading: syncing } ] = useMutateSyncProductsToGroup()

  const detachProduct = async (id: GQL_ID) => {
    await syncProducts({
      variables: {
        byFilter: false,
        product_group_id: groupId,
        product_ids: [ id ],
        operation: 'detach'
      }
    })
    refetch()
  }

  const { data, loading, error, refetch } = useQueryProducts({
    pager: {
      page,
      limit: ORDERS_PER_PAGE_LIMIT
    },
    filter,
    sort: {
      fieldName: tableSort.fieldName,
      direction: tableSort.direction
    }
  })

  // Передаем refetch наружу через ref
  React.useEffect(() => {
    if (refetchRef) {
      refetchRef.current = refetch
    }
  }, [ refetch, refetchRef ])

  const products = data?.products.edges ?? []

  const pageInfo = data?.products.pageInfo

  const showPagination = pageInfo?.lastPage !== 1


  return (
    <Panel>
      <Table
        autoHeight
        affixHeader
        loading={loading}
        data={products}
        sortColumn={tableSort.fieldName}
        sortType={tableSort.sortType}
        onSortColumn={handleSortColumn}
        rowHeight={100}
      >
        <Column verticalAlign="middle">
          <HeaderCell>Изображение</HeaderCell>
          <Cell>
            {(product: ProductListItem) => (
              <Avatar src={product?.preview?.url ?? NO_PHOTO_IMAGE} size="md" />
            )}
          </Cell>
        </Column>
        <Column flexGrow={1} verticalAlign="middle" sortable>
          <HeaderCell>ID</HeaderCell>
          <Cell dataKey="id">
            {(product: ProductListItem) => (
              <div>
                <div>ID: { product.id }</div>
                <div>арт. { product.xid }</div>
              </div>
            )}
          </Cell>
        </Column>

        <Column flexGrow={3} verticalAlign="middle" sortable>
          <HeaderCell>Название</HeaderCell>
          <Cell dataKey="name" />
        </Column>

        <Column flexGrow={4} verticalAlign="middle">
          <HeaderCell>Категории</HeaderCell>
          <Cell dataKey='category'>
            {(product: ProductListItem) => {
              product.categories.map(category => {
                return (
                  <div>
                    <span>123</span>
                  </div>
                )
              })
            }}
          </Cell>
        </Column>

        <Column flexGrow={1} verticalAlign="middle" sortable>
          <HeaderCell>Статус</HeaderCell>
          <Cell dataKey="status">
            {(product: ProductListItem) => (
              <CommonStatusLabel status={product.status} />
            )}
          </Cell>
        </Column>

        <Column flexGrow={2} fixed="right" verticalAlign="middle">
          <HeaderCell>Управление</HeaderCell>
          <Cell>
            {(product: ProductListItem) => (
              <>
                <Button
                  color="cyan"
                  size="xs"
                  onClick={() => detachProduct(product.id)}
                >
                  Удалить
                </Button>
              </>
            )}
          </Cell>
        </Column>

      </Table>

      {showPagination && (
        <Pagination
          last
          first
          next
          prev
          ellipsis
          total={pageInfo?.total ?? 0}
          activePage={page}
          pages={pageInfo?.lastPage}
          maxButtons={10}
          onSelect={handlePageSelect}
        />
      )}
    </Panel>
  )
}